export default function hexToRGBA(hex?: string, alpha = 1) {
  if (!hex) {
    return 'rgb(0, 0, 0, 1)';
  }
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  const rgb = `${r}, ${g}, ${b}`;

  if (alpha) {
    return `rgba(${rgb}, ${alpha})`;
  }

  return `rgb(${rgb})`;
}
